import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px custom-dark-bg rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = { class: "d-flex flex-stack mb-2" }
const _hoisted_11 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-hc w-100 mb-5"
}
const _hoisted_16 = { class: "indicator-label" }
const _hoisted_17 = { class: "indicator-progress" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_19 = { class: "text-center text-muted text-uppercase fw-bolder mb-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/svg/brand-logos/google-icon.svg",
  class: "h-20px me-3"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/svg/brand-logos/github.svg",
  class: "h-20px me-3"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.sign_in_to`)) + " Hacking Club", 1),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.new_here`)) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/sign-up",
              class: "link-primary fw-bolder"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.create_an_account`)), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            name: "email",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.password`)), 1),
            _createVNode(_component_router_link, {
              to: "/password-reset",
              class: "link-primary fs-6 fw-bolder"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.forgot_password`)), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "password",
            name: "password",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.sign_in`)), 1),
            _createElementVNode("span", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.please_wait`)) + "... ", 1),
              _hoisted_18
            ])
          ], 512),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.or`)), 1),
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AuthProvider('google'))),
            class: "btn btn-flex flex-center btn-light btn-lg w-100 mb-5"
          }, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.continue_with`)) + " Google ", 1)
          ]),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.AuthProvider('github'))),
            class: "btn btn-flex flex-center btn-light btn-lg w-100"
          }, [
            _hoisted_21,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.continue_with`)) + " Github ", 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}